import { IFilter } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import {
  isSelected,
  toggleOption,
} from "../../common-filters-components/toggleOption";
import ImageOption from "../../common-filters-components/ImageOption";
import { IProductDetails } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import OptionsCarousel from "../../common-filters-components/OptionsCarousel";
import { findChildernImages } from "./findChildernImages";

interface Props {
  filter: IFilter;
  state: string[];
  setState: (state: string[]) => void;
  unAvailabeKeys?: string[];
  isFilterDrawer?: boolean;
  productChildren: IProductDetails[];
  sliderMaxWidth?: number;
  outOfStockKeys?: string[];
}
const SelectImages: React.FC<Props> = ({
  filter,
  state,
  setState,
  unAvailabeKeys = [],
  isFilterDrawer = false,
  productChildren,
  sliderMaxWidth,
  outOfStockKeys,
}) => {
  const filterData = filter?.data;
  const is_multi_select = filter?.configurations?.is_multi_select;
  const options = findChildernImages(productChildren, filterData!) ?? [];

  return (
    <OptionsCarousel
      sliderMaxWidth={sliderMaxWidth}
      spacing={8}
      width={180}
      isFilterDrawer={isFilterDrawer}
    >
      {options
        ?.filter((op) => !isSelected(unAvailabeKeys, op.key))
        ?.map((option) => (
          <ImageOption
            is_multi_select={is_multi_select}
            key={option.key}
            label={option.value}
            image_src={option.image_url!}
            disabled={
              isSelected(unAvailabeKeys, option.key) ||
              isSelected(outOfStockKeys, option.key)
            }
            selected={isSelected(state, option.key)}
            toggleOption={() => {
              setState(toggleOption(state, option.key, is_multi_select));
            }}
          />
        ))}
    </OptionsCarousel>
  );
};
export default SelectImages;
